import styled from "styled-components";

export const Container = styled.div`
  overflow-x: hidden;
  border-radius: 10px;
`;
